import { Field, FieldProps } from 'formik';
import React, { useMemo } from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { Select, TextField } from 'ui-toolkit';
import { FeesTotalForm } from './FeesTotalForm';
import { ISettlementItemForm } from 'types/order/fees/ICreateSettlementItemForm';
import { ISettlementAndFeeCategoryDefinitionData } from 'types/order/fees/ISettlementAndFeeCategoryDefinition';
import { availablePropertiesBySelection } from './useAvailablePropertiesBySelection';

export interface ISettlementItemDetailsProps {
  lineItem: ISettlementItemForm;
  dirty: boolean;
  isReadOnly: boolean;
  options: ISettlementAndFeeCategoryDefinitionData[];
}

export const SettlementItemDetails: React.FC<ISettlementItemDetailsProps> = ({
  lineItem,
  dirty,
  options,
  isReadOnly,
}) => {
  const properties = availablePropertiesBySelection(options, lineItem.statementSettlementAndFeeCategoryDefinitionId);
  const feeCategoryOptions = useMemo(
    () => options.map((t) => ({ label: t.feeCategory, value: t.statementSettlementAndFeeCategoryDefinitionId })),
    [options]
  );
  return (
    <div className={`flex flex-row flex-wrap`}>
      <div className={`z-10 flex-grow basis-80 p-1`}>
        <Field name={`statementSettlementAndFeeCategoryDefinitionId`}>
          {({ field, form, meta }: FieldProps<string>) => (
            <Select
              {...field}
              id={'select-line-item-category'}
              isDisabled={!lineItem.isNew || isReadOnly}
              errorText={!!form.submitCount && meta.error}
              value={feeCategoryOptions.find((t) => field.value === t.value)}
              label={'Fee category'}
              options={feeCategoryOptions}
              onChange={(value: any, { action }: any) => {
                if (action === 'select-option') {
                  form.setFieldValue(field.name, value?.value);
                  form.setFieldTouched(field.name, true);
                  // The sidesheet loads with one blank Fee - this sets the fee category
                  form.setFieldValue(`statementFees.[0].statementSettlementAndFeeCategoryDefinitionId`, value?.value);
                  form.setFieldTouched(`statementFees.[0].statementSettlementAndFeeCategoryDefinitionId`, true);
                  // This sets the default value of the label that shows for the line item.
                  form.setFieldValue(
                    `stringSettlementStatementPropertyValues.${eFeePropertyNames.Name}`,
                    options.find((t) => t.statementSettlementAndFeeCategoryDefinitionId === value?.value)
                      ?.feeDescription
                  );
                  form.setFieldTouched(`stringSettlementStatementPropertyValues.${eFeePropertyNames.Name}`, true);
                }
              }}
              isRequired
            />
          )}
        </Field>
      </div>
      <div className={`flex-grow basis-80 p-1`}>
        <TextField
          name={`stringSettlementStatementPropertyValues.${eFeePropertyNames.Name}`}
          label={`Custom Fee Name`}
          placeholder={'Add name'}
          hintText={'This label is the fee name displayed on the settlement statement.'}
          readOnly={isReadOnly}
        />
      </div>
      {properties.canAddMoreFees && <FeesTotalForm values={lineItem} dirty={dirty} />}
    </div>
  );
};
